import i18n from 'i18next'

import { BaggageIcon } from 'entities/ticket/ui/card-of-ticket/ui/components/indicators'

import { Baggage } from 'shared/models/ticket.ts'

export const getBaggageText = (
  baggage?: Baggage,
  typeBaggage?: BaggageIcon,
) => {
  return typeBaggage === 'baggage'
    ? i18n.t('tickets_page.baggage', {
        piece: baggage?.piece,
        weight: baggage?.weight,
      })
    : i18n.t('tickets_page.сbaggage', {
        piece: baggage?.piece,
        weight: baggage?.weight,
      })
}
